// extracted by mini-css-extract-plugin
export var md = "_49-4";
export var semantic = "_49-5";
export var sm = "_49-3";
export var text = "_49-6";
export var toggleInput = "_49-0";
export var toggleSwitch = "_49-1";
export var xs = "_49-2";